import {NestedSelector} from "./controllers/nested-selector.ts";
import {__} from "./libraries/translations.ts";

const moment = require('moment');
const bootstrap = require('bootstrap');

$(document).ready(_ => {
    updateLayout('isPaid', '#price-details', 0, 'true');
    updateLayout('location-type', '#location-type-physical-details', 0, 'location-physical');
    updateLayout('location-type', '#location-type-virtual-details', 0, 'location-virtual');
    updateLayout('publishMoment', '#schedulePublication', 0, 'later');
    updateGender(0);
    updateStudies(0);

    // update payment method
    $('select[name="paymentMethod"]').change(e => {
        switchPaymentMethod($(e.target).val());
    });

    switchPaymentMethod($('[name=paymentMethod]').val());

    if ($('select[name="platformData[study]"]').length > 0) {
        const studyTypeSelect = $('select[name="platformData[studyType]"]');
        new NestedSelector([
            studyTypeSelect,
            $('select[name="platformData[study]"]'),
        ], window.studies, true);
        new NestedSelector([
            studyTypeSelect,
            $('select[name="platformData[university]"]'),
        ], window.universities, true);
    }
});

$('.updateCategory').on('click change', function () {

    const catId = $('#categorySelector input:checked').val();
    const catName = $('#categorySelector input:checked + .btn').text();

    $('#selectedCategoryId').val(catId);
    $('#selectedCategoryName').text(catName);
});


//when start date changes, end date changes too if its value is blank or earlier
$('input[name=startDate]').blur(function () {
    let startDateInput = $(this).val();
    let endDateInput = $('input[name=endDate]').val();

    let dateFormat = __('daterangepicker.format')
    let startDateArray = startDateInput.split("-");
    let endDateArray = endDateInput.split("-");
    let startDateCompute = "";
    let endDateCompute = "";

    if (dateFormat === 'DD-MM-YYYY') {
        startDateCompute = startDateArray.reverse().join("-");
        endDateCompute = endDateArray.reverse().join("-");
    } else if (dateFormat === 'MM-DD-YYYY') {
        startDateCompute = array(startDateArray[3], startDateArray[1], startDateArray[2]).join("-");
        endDateCompute = array(endDateArray[3], endDateArray[1], endDateArray[2]).join("-");
    }

    if (!endDateInput || Date.parse(startDateCompute) > Date.parse(endDateCompute)) {
        $('input[name=endDate]').val(startDateInput);
    }
});


function updateLayout(inputName, myId, myTiming, checkValue) {
    let myVal = $('input[name="' + inputName + '"]:checked').val();
    //alert(myVal);
    if (myVal == checkValue) {
        $(myId).slideDown(myTiming);
    } else {
        $(myId).slideUp(myTiming);
    }
}

$('input[name="isPaid"]').change(function () {
    updateLayout('isPaid', '#price-details', 400, 'true');
});

$('input[name="location-type"]').change(function () {
    updateLayout('location-type', '#location-type-physical-details', 400, 'location-physical');
    updateLayout('location-type', '#location-type-virtual-details', 400, 'location-virtual');
});

$('input[name="publishMoment"]').change(function () {
    updateLayout('publishMoment', '#schedulePublication', 400, 'later');
});

$('input[name="userRequirements[gender]"]').change(function () {
    updateGender(200);
});

$('input[name="study-type"], select[name="study"], select[name="school"]').change(function () {
    updateStudies(200);
});

$('select[name=startTimeMinute]').change(function() {
    let minute = $(this).val() - 15;
    let hour = $('select[name=startTimeHour]').val();
    if(minute < 0) {
        if(hour > 0) {
            minute += 60;
            hour--;
        } else {
            minute = '00';
        }
    }
    if(minute === 0) {
        minute = '00';
    }

    if($('select[name=gatherTimeHour]').val() === null && $('select[name=gatherTimeMinute]').val() === null) {
        $('select[name=gatherTimeHour]').val(hour);
        $('select[name=gatherTimeMinute]').val(minute);
    }
});

const photoLibraryElement = document.getElementById('photoLibrary');
if(photoLibraryElement) {
    const photoLibraryModal = new bootstrap.Modal(photoLibraryElement);
    $('.photo-library .item').on('click', (event) => {
        const id = $(event.currentTarget).data('id');
        const url = $(event.currentTarget).data('originalUrl');
        $('input[name=photoIdFromLibrary]').val(id);
        $('img.result').attr('src', url).show();
        photoLibraryModal.hide();
        $('#uploadPhoto').val('');
        $('input[name=originalImageBase64]').val('');
    });
}

$('.right-free-photo-notice h3').on('click', (event) => {
    $('.right-free-photo-notice .tips').toggle(300);
});


// Functions

function updateGender(myTiming) {
    let gender = $('input[name="userRequirements[gender]"]:checked').val();
    let message = "";
    if (!gender) {
        gender = "mixed";
    }
    if (gender == "mixed") {
        //hide message
        $('#gender-summary').slideUp(myTiming, function () {
            $('#gender-summary .js-summary').html(message);
        });
    } else {
        if (gender == "female") {
            message = "Mannen en non-binaire mensen krijgen deze activiteit niet te&nbsp;zien.";
        } else if (gender == "male") {
            message = "Vrouwen en non-binaire mensen krijgen deze activiteit niet te&nbsp;zien.";
        }
        //show message
        $('#gender-summary .js-summary').html(message);
        $('#gender-summary').slideDown(myTiming);
    }
}

function updateStudies(myTiming) {
    //construct string and show it
    let studyType = $('input[name="study-type"]:checked').val();
    let study = $('select[name="study"] option:selected').val();
    let school = $('select[name="school"] option:selected').val();

    let filterStrings = [
        " dit opleidingsniveau",
        " deze opleiding",
        " deze school"
    ];
    let filterValues = [
        studyType, study, school
    ];
    let showFilterStrings = [];

    let filtersString = "";
    let message = "";

    for (let i = 0; i < filterValues.length; i++) {
        if (filterValues[i] && filterValues[i] != -1) {
            showFilterStrings.push(i);
        }
    }
    let filterCount = showFilterStrings.length;
    for (let i = 0; i < filterCount; i++) {
        if (i != 0) {
            if (i + 1 == filterCount) {
                filtersString += " &eacute;n";
            } else {
                filtersString += ",";
            }
        }
        filtersString += filterStrings[showFilterStrings[i]];
    }

    if (filterCount) {
        message = "Alleen mensen die voldoen aan "
            + filtersString + " krijgen dit evenement te&nbsp;zien.";
        $('#studies-summary .js-summary').html(message);
        $('#studies-summary').slideDown(myTiming);
    } else {
        message = "";
        $('#studies-summary').slideUp(myTiming, function () {
            $('#studies-summary .js-summary').html(message);
        });
    }
}

function switchPaymentMethod(toMethod) {
    let allMethods = $('.payment-method');
    let selectedMethod = $('.payment-method.for-option-' + toMethod);
    allMethods.hide();
    allMethods.find('input').attr('disabled', true);
    selectedMethod.show();
    selectedMethod.find('input').removeAttr('disabled');
}

$('input[type=url]').on('blur', (event) => {
    validateUrl(event.target);
});

function validateUrl(field) {
    let string = field.value;
    if(string === '') {
        return field;
    }
    if (!~string.indexOf('https') && !~string.indexOf('http')) {
        string = 'https://' + string;
    }
    field.value = string;
    return field
}
